import { useQuery } from '@tanstack/react-query';
import { valuesService } from '../services/values.service';

export const useValues = (companyId: string) => {
  return useQuery({
    queryKey: ['company', companyId, 'values'],
    queryFn: () => valuesService.getAllCompanyValues(companyId),
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: !!companyId,
  });
};
